import supabase from "artifact/supabase";
import connected from "standard/connected";
import define from "standard/define";
import didPaint from "standard/didPaint";
import paint from "standard/paint";
import trait from "standard/trait";
import willPaint from "standard/willPaint";

@define("m-daily")
class Daily extends HTMLElement {
  #token;
  #daily;
  #owner;

  constructor() {
    super();
    this.attachShadow({ mode: "open" });
  }

  @willPaint
  async [trait.fetch]() {
    const ids = [
      "726046ba-7341-4a0f-b82d-d841c6b4df75",
      "45304395-f0fc-4116-918c-b15489d748bb",
    ];

    const { data: owner } = await supabase
      .from("team")
      .select("user_id, type(id)")
      .eq("user_id", this.dataset.user)
      .eq("school_id", this.dataset.school)
      .in("type.id", ids)
      .single();

    this.#owner = owner.type;

    const { data: team } = await supabase
      .from("team")
      .select("class_id")
      .eq("school_id", this.dataset.school)
      .eq("user_id", this.dataset.user)
      .single();

    const { data } = await supabase
      .from("classroom")
      .select("daily_id")
      .eq("class_id", team.class_id)
      .single();

    this.#daily = data.daily_id;
  }

  @connected
  @paint
  [trait.template]() {
    return `
      <div id="call" />
    `;
  }

  @didPaint
  [trait.daily]() {
    fetch("https://api.daily.co/v1/meeting-tokens", {
      method: "POST",
      headers: {
        Authorization:
          "Bearer 1713b7d71166dcc3f2d616e76d8116534c202c6adf89f927c77f70558ca86880",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        properties: {
          is_owner: true,
          room_name: `${this.#daily}`,
        },
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        this.#token = this.#owner != null ? data.token : "";
        console.log(data);

        const callFrame = window.DailyIframe.createFrame(
          this.shadowRoot.querySelector("#call"),
          {
            showLeaveButton: true,
            showFullscreenButton: true,
            iframeStyle: {
              position: "absolute",
              width: "100%",
              height: "100%",
              border: "0",
            },
          },
        );

        callFrame.join({
          url: `https://dulinoedu.daily.co/${this.#daily}`,
          token: `${this.#token}`,
        });
      });
  }
}

export default Daily;
